// Conciliación bancaria (CONC-A). Cada request tiene su _SUCCESS y su _ERROR:
// el _ERROR es lo que garantiza que el loading correspondiente vuelva a false.
const actions = {
    CONC_PREVISUALIZAR_REQUEST: 'CONC_PREVISUALIZAR_REQUEST',
    CONC_PREVISUALIZAR_SUCCESS: 'CONC_PREVISUALIZAR_SUCCESS',
    CONC_PREVISUALIZAR_ERROR: 'CONC_PREVISUALIZAR_ERROR',

    CONC_GUARDAR_MAPEO_REQUEST: 'CONC_GUARDAR_MAPEO_REQUEST',
    CONC_GUARDAR_MAPEO_SUCCESS: 'CONC_GUARDAR_MAPEO_SUCCESS',
    CONC_GUARDAR_MAPEO_ERROR: 'CONC_GUARDAR_MAPEO_ERROR',

    CONC_SUGERENCIAS_REQUEST: 'CONC_SUGERENCIAS_REQUEST',
    CONC_SUGERENCIAS_SUCCESS: 'CONC_SUGERENCIAS_SUCCESS',
    CONC_SUGERENCIAS_ERROR: 'CONC_SUGERENCIAS_ERROR',

    CONC_CONFIRMAR_REQUEST: 'CONC_CONFIRMAR_REQUEST',
    CONC_CONFIRMAR_SUCCESS: 'CONC_CONFIRMAR_SUCCESS',
    CONC_CONFIRMAR_ERROR: 'CONC_CONFIRMAR_ERROR',

    CONC_DESCONCILIAR_REQUEST: 'CONC_DESCONCILIAR_REQUEST',
    CONC_DESCONCILIAR_SUCCESS: 'CONC_DESCONCILIAR_SUCCESS',
    CONC_DESCONCILIAR_ERROR: 'CONC_DESCONCILIAR_ERROR',

    CONC_REGISTRAR_CARGA_REQUEST: 'CONC_REGISTRAR_CARGA_REQUEST',
    CONC_REGISTRAR_CARGA_SUCCESS: 'CONC_REGISTRAR_CARGA_SUCCESS',
    CONC_REGISTRAR_CARGA_ERROR: 'CONC_REGISTRAR_CARGA_ERROR',

    CONC_GET_CARGAS_REQUEST: 'CONC_GET_CARGAS_REQUEST',
    CONC_GET_CARGAS_SUCCESS: 'CONC_GET_CARGAS_SUCCESS',
    CONC_GET_CARGAS_ERROR: 'CONC_GET_CARGAS_ERROR',

    CONC_RESET_SESION: 'CONC_RESET_SESION',

    // `file` es el File del input; se guarda en el componente, no en el store
    previsualizar: ({ banco, tipo, file, forzarMapeo, filaEncabezado, anioReferencia }) => ({
        type: actions.CONC_PREVISUALIZAR_REQUEST,
        banco, tipo, file, forzarMapeo, filaEncabezado, anioReferencia,
    }),
    // Tras guardar el mapeo se vuelve a previsualizar el mismo archivo
    guardarMapeo: (mapeo, file) => ({ type: actions.CONC_GUARDAR_MAPEO_REQUEST, mapeo, file }),
    getSugerencias: ({ banco, tipo, filas }) => ({ type: actions.CONC_SUGERENCIAS_REQUEST, banco, tipo, filas }),
    confirmar: ({ tipo, indice, candidato, referenciaBancaria, fechaBanco }) => ({
        type: actions.CONC_CONFIRMAR_REQUEST,
        tipo, indice, candidato, referenciaBancaria, fechaBanco,
    }),
    desconciliar: ({ tipo, indice, registroId }) => ({ type: actions.CONC_DESCONCILIAR_REQUEST, tipo, indice, registroId }),
    registrarCarga: ({ file, resumen }) => ({ type: actions.CONC_REGISTRAR_CARGA_REQUEST, file, resumen }),
    getCargas: (query) => ({ type: actions.CONC_GET_CARGAS_REQUEST, query }),
    resetSesion: () => ({ type: actions.CONC_RESET_SESION }),
};

export default actions;
